import { render, staticRenderFns } from "./ChangeItemDetail.vue?vue&type=template&id=173bdc8d"
import script from "./ChangeItemDetail.vue?vue&type=script&lang=js"
export * from "./ChangeItemDetail.vue?vue&type=script&lang=js"
import style0 from "./ChangeItemDetail.vue?vue&type=style&index=0&id=173bdc8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports